import { CwtApiEntity, CwtCrudContract, CwtModel, CwtProp } from "@cawita/core-front/api";
import { Client } from "./client.model";
import { Address } from "../common";

@CwtModel({ name: 'client-address' })
@CwtCrudContract({ path: 'client-address' })
export class ClientAddress extends CwtApiEntity {
    @CwtProp({ ref: Client }) client: Client;
    @CwtProp({ ref: Address }) address: Address;
}